
import { config } from "../config/config";
import { utils } from "@utils/utils";
import logUtil from "../utils/log-utils";

export default {
	init () {
		//设置要记录的日志级别
		this.setRecordLevels();
		this.overrideConsole();
	},
	//设置要记录的日志levels，优先使用用户自定义的，否则使用默认的
	setRecordLevels () {
		if (window.xkwTracker && window.xkwTracker.$log_record_levels) {
			const levels = window.xkwTracker.$log_record_levels;
			this.assertLevels(levels);
			this.logLevels = window.xkwTracker.$log_record_levels;
		} else {
			this.logLevels = config.DEFAULT_RECORD_LEVELS;
		}
	},
	//判断参数是否合法
	assertLevels (recordLevels) {
		let errorLevels = [];
		for (let level of recordLevels) {
			//判断定义的
			if (!console[level]) {
				errorLevels.push(level);
			}
			if (errorLevels.length > 0) {
				throw new Error("level定义不合法，请检查：" + errorLevels.join(","));
			}
		}
	},
	//重写console的所有方法,将日志写入localStorage
	overrideConsole () {
		//给console添加一个自定义名字，避免重复重写，造成重复上报
		const consoleName = "xkw-console";
		if (console.name === consoleName) {
			return;
		}
		console.name = consoleName;
		if (!window.localStorage) {
			console.error("浏览器版本过低，不支持localStorage");
			return;
		}
		for (let level of this.logLevels) {
			let oldLog = console[level];
			console[level] = function (...args) {
				//日志level
				const logLevel = level;
				//应用名称
				const appName = `${window.xkwTracker.$product || "未知产品"} - ${window.xkwTracker.$application || "未知应用"}`;
				//时间
				const time = utils.formatDate(new Date(), "yyyy-MM-dd hh:mm:ss");
				//用户ID
				const userId = window.xkwTracker.$user_id || "未知用户";
				//完整url
				const url = window.location.href;
				//获取userAgent
				const userAgent = window.navigator.userAgent;
				//日志正文
				const logString = args.map((arg) => {
					if (typeof arg === "object") {
						//JSON stringify的时候避免循环引用和原型打印，只打印自身属性
						return JSON.stringify(arg, (key, value) => {
							if (key && !arg.hasOwnProperty(key)) {
								return undefined;
							}
							return value;
						});
					} return arg;
				}).join(",");
				const logContent = [logLevel, appName, time, userId, url, userAgent, logString].join(config.LOG_SEPERATOR);
				logUtil.writeLog(logContent);
				//调用原始的console.log
				oldLog && oldLog.apply && oldLog.apply(console, args);
			};
		}
	},
};
